import { useCallback } from 'react';

import { useApplicationContext } from '../applicationContext';

import { formatDate, TFormatDateOptions } from './formatDate';

/**
 * formatDate с referenceNow из контекста (serverTimestamp с SSR) — одинаковый первый рендер на сервере и клиенте.
 */
export function useFormatDate() {
  const { custom } = useApplicationContext();
  const ts = custom.serverTimestamp;

  return useCallback(
    (date: Date, options?: Omit<TFormatDateOptions, 'referenceNow'>) => {
      const referenceNow = new Date(ts ?? Date.now());
      return formatDate(date, { ...options, referenceNow });
    },
    [ts],
  );
}
